import React from 'react'
import { Tabs } from '@enamelai/design-system'

export type ReportViewTabOption<TValue extends string = string> = {
  label: string
  value: TValue
  disabled?: boolean
}

type ReportViewTabsProps<TValue extends string = string> = {
  options: ReportViewTabOption<TValue>[]
  value?: TValue
  onChange: (value: TValue) => void
  className?: string
}

function ReportViewTabs<TValue extends string = string>({
  options,
  value,
  onChange,
  className,
}: ReportViewTabsProps<TValue>): React.ReactElement {
  return (
    <Tabs
      items={options.map((option) => ({
        id: option.value,
        label: option.label,
      }))}
      value={value}
      onChange={(nextValue) => {
        const option = options.find(
          (candidate) => candidate.value === nextValue,
        )
        if (!option?.disabled) onChange(nextValue as TValue)
      }}
      className={className}
    />
  )
}

export default ReportViewTabs
